import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AngularFireDatabase,AngularFireList } from '@angular/fire/database';
import { GlobalVars } from '../../../../providers/globalVars';
import { OrderByPipe } from '../../../../pipe/orderbypipe';
import { map, first, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { TabsPage } from '../../../../tabs/tabs.page';
import { ModalController,IonRouterOutlet,NavController,AlertController,IonContent } from '@ionic/angular';
import { DiscountdetailComponent } from '../../../../pages/support/discountdetail/discountdetail.component';
import { AngularFireAuth } from '@angular/fire/auth';

import { FirstvisitmodalPage } from '../../../support/firstvisitmodal/firstvisitmodal.page';

@Component({
  selector: 'app-servicemain',
  templateUrl: './servicemain.page.html',
  styleUrls: ['./servicemain.page.scss'],
})
export class ServicemainPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  shownow:any[] = [];
  infobanner:any[] = [];
  chcat:any;
  dir:any;
  advlistall:any[] = [];
  advlist:any[] = [];
  advpage:number = 0;
  serviceslt:any;
  servicelist:any[] = [];
  setfield:any[] = [];
  serviceid:any;
  discountlist:any[] = [];
  discountpage:number = 0;
  discountinfo:any[] = [];
  discounttemp:any;

  loadingboard: boolean = false;
  loadingdiscount: boolean = false;
  loadingservice: boolean = false;
  loadingadv: boolean = false;

  uid:any;

  Arr = Array; 
  datenow:any = new Date().getTime();

  slideOpt_centered = {
      slidesPerView: 'auto',
      spaceBetween: 20,
      zoom:false,
      // centeredSlides: true,
      autoplay: {
        delay: 3000,
      },
      loop: false,
      pagination: false,
    }
    loaddone: any = false;
  slideOpttop = {
    initialSlide: 0,
    speed: 5000
  };
  scrVal: any;
  lastScrVal: any;
  ltdropdown:boolean = false;

  discountObj:any = {};
  discountSnap:any;

  @ViewChild('citybox') citybox;
  @ViewChild('cityboxInner') cityboxInner;

  colorlist = [
    ['#ffd494','#f6b37f','#fd835f','#ff7660','#f68282','#f68399','#ea83c2','#c481d8','#a882e8','#8b90e8'],
    ['#889ae9','#90aaf5','#8db7f6','#6b9eea','#70b8e6','#75d3eb','#75d3eb','#55e1c8','#55e19a','#a7eb88'],
    ['#bde566','#d2e05f','#e0e476','#eddb5f','#f7ba5b','#f79d5b','#f78b5b','#f7785b','#fc6555','#fc6555']
  ];
  currentloclan:any;
  thisfile = 'servicemain';

  constructor(public afDB: AngularFireDatabase,public gv: GlobalVars,public router: Router,private afAuth: AngularFireAuth,
    public modalCtrl:ModalController,private orderby: OrderByPipe,public storage:Storage,private outlet:IonRouterOutlet, public navCtrl: NavController, public alertCtrl:AlertController) {
    this.gv.getmainbanner().then(rst=>{if(rst)this.infobanner = rst});
   }

  ngOnInit(){
    this.gv.getRegion(); //열려있는 지역(도시)값 불러옴
    this.outlet.swipeGesture = false;
    // this.loaddata();
  }
  ionViewDidEnter(){
    this.gv.selectedcontent = this.content;
    if(this.currentloclan != this.gv.loc + '_' + this.gv.lan)
      this.loaddata();
  }
  loaddata(){
    this.currentloclan = this.gv.loc + '_' + this.gv.lan;
    if(this.gv.loc && this.gv.lan)
       this.doRefresh();
     else
      {setTimeout(_=>{this.currentloclan = this.gv.loc + '_' + this.gv.lan; this.doRefresh()},5000)}
  }
  ionViewWillLeave() {this.gv.selectedcontent = null;}
  ionViewDidLeave(){
    this.outlet.swipeGesture = true;
  }

  sltcity(city){
    if(this.gv.uid){
      this.afDB.database.ref('/userProfile/' + this.gv.uid + '/loc').set(city);
    }
    this.gv.setlocinlocal(city)
    this.gv.loc = city;
    // this.ltdropdown = false;
    this.cityboxOff();
    this.currentloclan = this.gv.loc + '_' + this.gv.lan;
    this.getdata();
    //this.refreshdata()
  }
  
  cityboxToggle() {
    if( this.ltdropdown == false ) {
      this.cityboxOn();
    } else {
      this.cityboxOff();
    }
  }
  cityboxOn() {
    this.citybox.nativeElement.style.display = 'block';
    this.cityboxInner.nativeElement.scrollLeft = 0;
    setTimeout(_=>{
      this.ltdropdown = true;
    },50);
  }
  cityboxOff() {
    this.ltdropdown = false;
    setTimeout(_=> {
      this.citybox.nativeElement.style.display = 'none';
      this.ltdropdown = false;
    }, 300);
  }


  
  async remove(key){
    const alert = await this.alertCtrl.create({
      // header: hd,
      message: '삭제 하시겠어요?',
      buttons: [
        {
          text: '취소',
          role: 'cancel'
        },
        {
          text: '삭제',
          handler: () => {
            
            this.afDB.database.ref('/discount/' + key).remove();
            // this.afDB.database.ref('/discount/').once('value').then(list=>{
            //   if( list.val() ) {
            //     let _ = list.val();
            //     let _disc = Object.keys(_).filter((disc)=>{
            //       if( _[disc].id == item.id ) return {disc: _[disc]}
            //     });
            //     if( _disc.length == 1 ) {
            //       this.afDB.database.ref('/discount/' + _disc[0]).remove();
            //     }
            //   }
            // });
            
            setTimeout(_=>{
              this.getdiscount();
            },1000);
          }
        }
      ] 
    });
    return await alert.present();
  }

  godiscount(id){
    // this.router.navigate(['/tabs/sm/chview/' + id]);
    this.navCtrl.navigateForward('/tabs/sm/chview/' + id);
  }

  editdiscount(key) {
    // this.navCtrl.navigateForward(['/tabs/sm/adddiscount/' + this.itemId]);
    this.navCtrl.navigateForward(['/tabs/sm/adddiscount/' + key]);
  }

  getservice(){
    this.afDB.database.ref('/localmanage/' + this.gv.loc + '_' + this.gv.lan + '/service')
    .once('value').then(items=>{
      this.servicelist = [];
      items.forEach(item=>{
        let service = item.val();
        if(service.show)
        {
          this.servicelist.push({
            imgurl: service.imgurl,
            name:service.name, 
            chid:service.detail.chid, 
            label:service.label,
            topcat: service.detail.topcat,
            items:this.afDB.database.ref('/list').orderByChild('categoryId').equalTo(service.detail.chid).once('value').then(rst=>{
              let data = [];
              rst.forEach(r=>{
                let serviceitem = r.val();
                if(serviceitem.category == service.detail.topcat)
                  data.unshift({
                    key:r.key, 
                    img:serviceitem.imagethumb?serviceitem.imagethumb[0].url:'', 
                    title:serviceitem.title,
                    chicon: this.afDB.database.ref('/category/'+service.detail.chid+'/imagethumb/0/url/').once('value').then(rst=>{
                      if( rst.val() ) return rst.val();
                    })
                  });
              })
              return data;
            })
          });
          // console.log(this.servicelist);
        }
      })
    })
  }

  getdiscount(){
    this.loadingdiscount = false;
    this.afDB.database.ref('/discount').orderByChild("loclancode")
      .startAt(this.gv.loc).endAt(this.gv.loc + "aaaaaaaaaaaaaaa")// + '_' + this.gv.lan)
      .once('value').then(items=>{
        this.discountlist = [];
        this.discountinfo = [];
        // this.discountinfo = this.orderby.transform(items.val(), 'ptype', 'asc');
        // let i = 0;
        items.forEach(_=>{
          if(_.val()) {
            let data = _.val();
            data.itemkey = _.key;
            this.discountinfo.push(data);
          }
          // this.discountinfo[i].itemkey = _.key;
          // i++;
        });
        // this.discounttemp = Object.keys(items.val()).map(key => ({key: key, data: items.val()[key]}));
        // console.log(this.discounttemp);
        this.chkdiscount();
    }).then(_=>{
      // this.loaddone = true;
      if(this.gv.needfillfav) { // 리, 비회원이 지역값 없을때 최초 1회만 노출 되어야 합니다.
        this.firstvisitModal();
      } else {
        this.storage.get('savedaccloc').then(rst=>{
          if(!rst && !this.gv.loc)
            this.firstvisitModal();
        })
      }
    });
  }

  async firstvisitModal() {
    const modal = await this.modalCtrl.create({
      component: FirstvisitmodalPage,
      cssClass: 'ph-custom-modal',
      backdropDismiss: false,
      componentProps: < null > {p:this}
      // componentProps: < null > {
      //   list: list,
      //   index: index
      // }
    });
    //modal.onDidDismiss().then(_=>{
    //  this.refreshdata();
    //})
    return await modal.present();
  }
  
  getdata() {
    this.getdiscount();
    this.getservice();
    /*

        this.afDB.database.ref('/localmanage/' + this.chcat).on('value', items=>{
        //광고 셋업
        if(items.val()['ad']['home'])
        {
        this.advlist = [];
        items.val()['ad']['home'].forEach(item=>{
          if(item.show == 'all' && (new Date().getTime() > new Date(item.startdate).getTime() 
        && new Date().getTime() < new Date(item.enddate).getTime()))
        {item.orderrate = Math.floor(Math.random() * item.advorder);
        this.advlist.push(item);}
        this.advlist = this.orderby.transform(this.advlist,'orderrate','desc');
        })
        this.loadingadv = true;
        }
        //배너 셋업
        if(items.val()['banner'])
        {
        let banner = [];
        items.val()['banner'].forEach(item=>{
          if(item.show)
           banner.push(item);
        })
        banner = this.orderby.transform(banner,'point','desc');
        if(this.infobanner.length == banner.length)
        {
         for(let i = 0; i < this.infobanner.length; i++) 
          {
              if(!JSON.stringify(this.infobanner[i]).includes(JSON.stringify(banner[i])))
              {
                this.infobanner = banner;
                this.gv.setmainbanner(banner);
                break;
              }
          }
        }
        else
        {
        //settimeout없이는 동기화 실패.. why??
        setTimeout(_=>this.infobanner = banner,2000)
        this.gv.setmainbanner(banner);
        }
        }
        
        // 서비스셋업
        if(items.val()['service']) {
          let service = items.val()['service'];
          this.servicelist = [];
            Object.keys(service).forEach(key=>{
              if(service[key].show) {
                this.servicelist.push({
                  key: key,
                  label: service[key]['label'],
                  imgurl: service[key]['imgurl'],
                  name: service[key]['name'],
                  linkurl: service[key]['linkurl'] ? service[key]['linkurl'] : '/servicedetail/'+key+'/'+this.chcat
                });
              }
            });
          }
        });*/
  }

        
        

        /*
        this.afDB.list('/advertise/' + this.chcat + '/maintop').subscribe(items=>{
        this.advlistall = items;
        this.advlist = items;
        this.loadingadv = true;
        //this.chkadv();
        });*/
/*
    this.afDB.list('/mainbanner/' + this.chcat, {query: {
                        orderByChild: "show",
                        equalTo: true
                      }}).pipe(map((data) => { 
                        let count = data.length;
                        let banner = [];
        return data.map((data) => {
          this.afDB.database.ref('/list' + '/' +  data.itemid + '/userId').once('value').then(rst=>{
            this.afDB.database.ref('/userProfile/' +  rst.val() + '/nickname').once('value').then(val => 
            {
            count--;  
            data.nickname = val.val();
            banner.push(data);
            if(count == 0)
            {
              if(this.infobanner.length == banner.length)
              {
                for(let i = 0; i < this.infobanner.length; i++) 
                {
                    if(!JSON.stringify(this.infobanner[i]).includes(JSON.stringify(banner[i])))
                    {
                      this.infobanner = banner;
                      this.gv.setmainbanner(banner);
                      break;
                    }
                }
              }
              else
              {
              this.infobanner = banner;
              this.gv.setmainbanner(banner);
              }
            }
            });
            })
          return data
      })
      }) ).subscribe(items=>{
        if(!items.length)
        {
          this.infobanner = [];
        }
        */
    /*
    if(this.infobanner.length == banner.length)
    {
      for(let i = 0; i < this.infobanner.length; i++) 
      {
          if(!JSON.stringify(this.infobanner[i]).includes(JSON.stringify(banner[i])))
          {
            console.log('다름..');
            this.infobanner = banner;
            this.gv.setmainbanner(banner);
            break;
          }
      }
    }
    else
    {
    this.infobanner = banner;
    this.gv.setmainbanner(banner);
    }
    this.loadingbanner = true;
  });
  this.loadservices();
  }

  jumpbanner(slide){
  let today = new Date();
  let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
  this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/mbclick').transaction(view=>{
    return (view || 0) + 1;
  })
  slide.getActiveIndex().then(index=>{
    if (index == 0)
      index = this.infobanner.length;
    else if(index > this.infobanner.length)
      index = 1;
    this.router.navigate([this.infobanner[index-1].linkurl]);
  })
  }

  jumpadv(slide){
  let today = new Date();
  let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
  this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/adclick').transaction(view=>{
    return (view || 0) + 1;
  })
  slide.getActiveIndex().then(index=>{
    if (index == 0)
      index = this.advlist.length;
    else if(index > this.advlist.length)
      index = 1;
    this.router.navigate(['/chview/' + this.advlist[index-1].id]);
  })
  }

  chkadv(){
    this.advpage = 0;
    this.advlist = [];
    this.advlistall.forEach(item => {
          if(item.show == 'all' && (new Date().getTime() > new Date(item.startdate).getTime() 
          && new Date().getTime() < new Date(item.enddate).getTime()) )
          {
            item.orderrate = Math.floor(Math.random() * item.advorder); // 
            this.advlist.push(item);
          }
        });
    this.loadingadv = true;
  }

  ionViewDidEnter(){
  this.chkdiscount();
  
    setTimeout(_=>{
       this.loaddone = true;
    },1000);
  }

  loadservices(){
      this.servicelist = [];
      var loclan = 'cairns_kr';
      if(this.chcat)
        loclan = this.chcat;
      
      this.afDB.database.ref('/services').orderByChild('loclancode').equalTo(loclan).once('value')
      .then(services=>{
          services.forEach(service => {
            if(service.val().active == true)
              {
              this.servicelist.push({$key:service.key, data:service.val()});
              }
          });
          if(this.servicelist.length)
          {
          this.servicelist = this.orderby.transform(this.servicelist, 'data.point', 'desc');
          this.serviceslt = this.servicelist[0].data.name;
          this.serviceid = this.servicelist[0].$key;
          if(this.servicelist[0].data.fieldlist)
            this.setfield = this.servicelist[0].data.fieldlist
          if(this.servicelist[0].data.formname)
            this.formname = this.servicelist[0].data.formname
          }
          this.loadingservice = true;
        })
    }*/

  chkdiscount()
  {
    if(this.discountinfo)
    {
      this.discountlist = [];
      // this.discountinfo.forEach(discount=>{
      this.discountinfo.forEach(discount=>{
        
        if(discount.ptype == 'zday') {
          // console.log("Date().getTime()___________________= " + new Date().getTime());
          // console.log("Date(discount.startdate).getTime() = " + (new Date(discount.startdate).getTime() - 1000*60*60*24*10));
          if(
            new Date().getTime() >= new Date(discount.startdate).getTime() - 1000*60*60*24*10 && 
            new Date().getTime() < new Date(discount.enddate).getTime() + 1000*60*60*24
            ) {
              discount.startdiff = Math.ceil((new Date().getTime() - new Date(discount.startdate).getTime() - (1000*60*60*24))/(1000*60*60*24));
              discount.enddiff = Math.ceil((new Date(discount.enddate).getTime() - new Date().getTime())/(1000*60*60*24));
              discount.order = discount.discountorder?discount.enddiff-discount.discountorder:discount.enddiff;
              this.discountlist.push(discount);
            }
        }
        else if(discount.ptype == 'weekly') {
          var today = new Date().getDay();
          var chksameday = false;
          discount.day.forEach(day => {
            if(day == today)
              chksameday = true;
          });
          discount.order = discount.discountorder?7-discount.discountorder:7;
          if(chksameday){
            this.discountlist.push(discount);
          }
        }
        else if(discount.ptype == 'time') {
          var temphour = parseInt(discount.starttime.split(':')[0]) - 3;
          var hourstring = "";
          if(temphour < 0)
            hourstring = "00";
          else if(temphour < 10)
            hourstring = "0" + temphour.toString();
          else
            hourstring = temphour.toString();
          var adjstarttime = hourstring + ":" + discount.starttime.split(':')[1];

          var timenow = new Date().getHours() + ":" + new Date().getMinutes();
          discount.order = discount.discountorder?15-discount.discountorder:15;
          //if(timenow > adjstarttime && timenow < discount.endtime)
          {
            this.discountlist.push(discount);
          }
        }
      })
      this.discountlist = this.discountlist.map(item=>{
        this.afDB.database.ref(this.gv.getListDir(item.loclancode) + '/' + item.id).once('value').then(
          rst=>item.data = rst.val()
        )
        return item;
      })
      this.loadingdiscount = true;
      // console.log(this.discountlist);
    }
  }

  showrecent(){
    //this.gv.param['recentdata'] = this.boardlist;
  }

  goservice(link)
  {
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/service').transaction(view=>{
      return (view || 0) + 1;
    })
    this.router.navigate(['/tabs/sm/' + link]);
  }

  doRefresh(refresh?) {
    this.getdata();
    setTimeout(_=>{
      if(refresh) {
        refresh.target.complete();
      }
    },500);
  }
}
